import React, { useRef, useEffect, useMemo } from "react";
import { Container } from "@pixi/react";
import RoyalCollectReelBackController, {
  SPINE_CONFIG,
} from "./RoyalCollectReelBackController";
import { Settings } from "../../settings";
import { safeInit } from "../../utilities";

const RoyalCollectReelBack = ({
  symbolWidth,
  symbolHeight,
  dimensions,
  dividerDimensions,
}) => {
  const reelBackControllerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && !reelBackControllerRef.current) {
      safeInit(() => {
        reelBackControllerRef.current = new RoyalCollectReelBackController(
          containerRef.current,
          symbolWidth,
          symbolHeight,
          dimensions,
          dividerDimensions,
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (reelBackControllerRef.current) {
      reelBackControllerRef.current.resizeReelBack(
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbolHeight]);

  const containerPosition = useMemo(() => ({
    x: symbolWidth * Settings.REEL_COUNT * SPINE_CONFIG.horizontalOffset,
    y: -symbolHeight * Settings.SYMBOLS_VISIBLE * SPINE_CONFIG.verticalOffset,
  }), [symbolWidth, symbolHeight]);

  return (
    <Container
      y={containerPosition.y}
      x={containerPosition.x}
      ref={containerRef}
      name="royal_collect_back_texture"
      zIndex={1}
    />
  );
};

export default RoyalCollectReelBack;
